import { api, AuthResponse, ApiResponse } from './api';

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface User {
  id: number;
  nombre: string;
  email: string;
  rol: string;
  rol_id?: number;
  rol_display?: string;
}

export interface RegisterData {
  nombre: string;
  email: string;
  password: string;
  rol: string;
}

export interface ChangePasswordData {
  currentPassword: string;
  newPassword: string;
}

export const authService = {
  // Iniciar sesión
  login: async (credentials: LoginCredentials): Promise<AuthResponse> => {
    console.log('AuthService.login called with:', { email: credentials.email });
    const response = await api.post<AuthResponse>('/auth/login', credentials);
    console.log('AuthService.login response:', response.data);
    return response.data;
  },

  // Obtener perfil del usuario actual
  getProfile: async (): Promise<User> => {
    const response = await api.get<ApiResponse<User>>('/auth/profile');
    return response.data.data!;
  },

  // Registrar nuevo usuario (solo admins)
  register: async (userData: RegisterData): Promise<ApiResponse> => {
    const response = await api.post<ApiResponse>('/auth/register', userData);
    return response.data;
  },

  // Cambiar contraseña
  changePassword: async (
    passwordData: ChangePasswordData
  ): Promise<ApiResponse> => {
    const response = await api.put<ApiResponse>(
      '/auth/change-password',
      passwordData
    );
    return response.data;
  },

  // Cerrar sesión (cliente)
  logout: () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
  },

  // Verificar si hay una sesión activa
  isAuthenticated: (): boolean => {
    const token = localStorage.getItem('authToken');
    const user = localStorage.getItem('user');
    return !!(token && user);
  },

  // Obtener token actual
  getToken: (): string | null => {
    return localStorage.getItem('authToken');
  },

  // Obtener usuario actual del localStorage
  getCurrentUser: (): User | null => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        return JSON.parse(userStr);
      } catch {
        return null;
      }
    }
    return null;
  },

  // Guardar sesión en localStorage
  saveSession: (token: string, user: User): void => {
    localStorage.setItem('authToken', token);
    localStorage.setItem('user', JSON.stringify(user));
  },
};

export default authService;
